import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedFotoCantiere } from '../../../types/red'
import { CATEGORIE_FOTO_LABEL } from '../../../constants/red'
import { redApi } from '../../../services/api'

const TabFotoCantiere: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [foto, setFoto] = useState<RedFotoCantiere[]>([])
  const [loading, setLoading] = useState(true)
  const [uploading, setUploading] = useState(false)
  const [categoria, setCategoria] = useState('pre_lavori')
  const [descrizione, setDescrizione] = useState('')

  const load = () => {
    redApi.fotoCantiere.listByImmobile(immobile.id).then(res => {
      setFoto(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleUpload = async (file: File) => {
    setUploading(true)
    try {
      const fd = new FormData()
      fd.append('immobile_id', immobile.id)
      fd.append('categoria', categoria)
      fd.append('data_scatto', new Date().toISOString())
      fd.append('descrizione', descrizione)
      fd.append('file', file)
      await redApi.fotoCantiere.upload(fd)
      toast.success('Foto caricata')
      setDescrizione('')
      load()
      onUpdate()
    } catch { toast.error('Errore upload') }
    finally { setUploading(false) }
  }

  if (loading) return <div className="text-gray-400">Caricamento...</div>

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Foto Cantiere</h2>
        <div className="flex items-center gap-2">
          <select className="select text-sm" value={categoria} onChange={e => setCategoria(e.target.value)}>
            {Object.entries(CATEGORIE_FOTO_LABEL).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <input className="input text-sm" placeholder="Descrizione" value={descrizione} onChange={e => setDescrizione(e.target.value)} />
          <label className="btn-primary text-sm cursor-pointer">
            {uploading ? 'Caricamento...' : '+ Carica foto'}
            <input type="file" accept="image/*" className="hidden" onChange={e => { const f = e.target.files?.[0]; if (f) handleUpload(f) }} />
          </label>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {foto.map(f => (
          <div key={f.id} className="relative group">
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden border border-gray-200">
              <img src={`/api/red/foto-cantiere/${f.id}/download`} alt={f.descrizione || 'Foto'} className="w-full h-full object-cover" />
            </div>
            <div className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <button onClick={async () => { if (!confirm('Eliminare?')) return; await redApi.fotoCantiere.delete(f.id); toast.success('Eliminata'); load() }} className="bg-red-600 text-white text-xs px-2 py-1 rounded">🗑</button>
            </div>
            <div className="text-xs text-gray-500 mt-1">
              {CATEGORIE_FOTO_LABEL[f.categoria] || f.categoria}
              {f.descrizione && ` · ${f.descrizione}`}
            </div>
            <div className="text-xs text-gray-400">{new Date(f.data_scatto).toLocaleDateString('it-IT')}</div>
          </div>
        ))}
      </div>
      {foto.length === 0 && <div className="text-center py-10 text-gray-400">Nessuna foto caricata.</div>}
    </div>
  )
}

export default TabFotoCantiere
